import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;

  width: 100%;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #babaca;
`;
